import axios from 'axios';
import { PAGES_ROOT } from 'config/api';

const plaidActions = {
  FETCH_ACCOUNTS: 'PLAID_FETCH_ACCOUNTS',
  FETCH_ACCOUNTS_FAILED: 'PLAID_FETCH_ACCOUNT_FAILED',
  FETCH_ACCOUNTS_SUCCESS: 'PLAID_FETCH_ACCOUNT_SUCCESS',
  HANDLE_VERIFICATION_QUESTIONS: 'PLAID_HANDLE_VERIFICATION_QUESTIONS',
  LINK_VERIFICATION: 'PLAID_LINK_VERIFICATION',
  LINK_VERIFICATION_FAILED: 'PLAID_LINK_VERIFICATION_FAILED',
  LINK_VERIFICATION_SUCCESS: 'PLAID_LINK_VERIFICATION_SUCCESS',
  REFETCH_ACCOUNTS: 'PLAID_REFETCH_ACCOUNTS',
  SAVE_QUESTIONS: 'PLAID_SAVE_QUESTIONS',
  UPDATE_META: 'PLAID_UPDATE_META',
  UPDATE_META_DONE: 'PLAID_UPDATE_META_DONE',

  fetchAccounts: (metadata, callback, requestId) => ({
    payload: {
      callback,
      metadata,
      requestId,
    },
    type: plaidActions.FETCH_ACCOUNTS,
  }),
  fetchAccountsFailed: (data) => ({
    payload: { data },
    type: plaidActions.FETCH_ACCOUNTS_FAILED,
  }),
  fetchAccountsSuccess: (data) => ({
    payload: { data },
    type: plaidActions.FETCH_ACCOUNTS_SUCCESS,
  }),

  handleVerificationQuestions: (data) => ({
    payload: { data },
    type: plaidActions.HANDLE_VERIFICATION_QUESTIONS,
  }),
  linkVerification: (plaid, callback) => ({
    payload: {
      callback,
      plaid,
      request: (pageName, activeGroup) => () =>
        axios({
          method: 'GET',
          url: `${PAGES_ROOT}/${pageName}/groups/${activeGroup}/actions/isLinkVerificationAllowed`,
        }),
    },
    type: plaidActions.LINK_VERIFICATION,
  }),

  linkVerificationFailed: (data) => ({
    payload: { data },
    type: plaidActions.LINK_VERIFICATION_FAILED,
  }),
  linkVerificationSuccess: () => ({
    type: plaidActions.LINK_VERIFICATION_SUCCESS,
  }),
  refetchAccounts: (plaidRef) => ({
    payload: {
      plaidRef,
      refetch: true,
    },
    type: plaidActions.REFETCH_ACCOUNTS,
  }),
  saveQuestions: (data) => ({
    payload: {
      request: (pageName) => () =>
        axios({
          data,
          method: 'POST',
          url: `${PAGES_ROOT}/${pageName}/groups/FUNDING_TRANSFER_EXT/actions/verifyQuestions`,
        }),
    },
    type: plaidActions.SAVE_QUESTIONS,
  }),
  updateMeta: (metaData) => ({
    payload: {
      request: (pageName, activeGroup) => () =>
        axios({
          data: metaData,
          method: 'POST',
          url: `${PAGES_ROOT}/${pageName}/groups/${activeGroup}/actions/updateMetadata`,
        }),
    },
    type: plaidActions.UPDATE_META,
  }),
  updateMetaDone: () => ({
    type: plaidActions.UPDATE_META_DONE,
  }),
};

export default plaidActions;
